import React, {PureComponent} from 'react';
import FormCore from '@/components/display/form/formCore';
import PropTypes from 'prop-types';
class asyncForm extends PureComponent {
  constructor (props) {
    super(props);
    this.props = props;
    this.layout = [
      'inline', // 横向布局
      'horizontal' // 纵向布局
    ];
    this.state = {
      options: []
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  componentWillMount () {
    // 配置formItem的构建信息

    this.formConfig = {
      childItems: [
        {
          type: 'input', // 定义表单元素基础类型
          inputType: 'text', // 定义表单元素的子类型
          param: { // 定义表单元素的参数对象
            name: 'application', // 参数名称
            type: 'string' // 参数类型，用来做类型检测
          },
          labelName: 'application', // label名称
        },
        {
          type: 'buttonGp', // 表单最终执行组
          buttonArr: [
            {
              btnType: 'submit',
              text: '查询',
              icon:'search'
            }
            ]
          }
        ],
      defaultParams: {
        bizTraceNo: 'yMCCxmDi9TCsMZlKbGkQsw==',
        application: 'sc-app'
      },
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: 'grid', // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      context: this,
      tableKey: this.props.tableKey
    };
  }

  fetchApi (param) {
    // 当设置formTarget为ajax时，执行自定义提交事件。
    if (this.formConfig.formTarget === 'grid') {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      // TODO 执行异步请求或其他
      return;
    }
  }

  render () {
    return <FormCore
      formConfig={this.formConfig}
      fetchApi={this.fetchApi.bind(this)}
      {...this.props} />;
  }

}

export default asyncForm;

asyncForm.propsType = {
  layout: PropTypes.string,
  modalSubmit: PropTypes.func,
  tableKey: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/AntD/pages/example/asyncGenerateTable/form/asyncForm.js